import { render } from "./BsTemplateOwnerView.vue?vue&type=template&id=0304c5c7&scoped=true"
import script from "./BsTemplateOwnerView.vue?vue&type=script&lang=js"
export * from "./BsTemplateOwnerView.vue?vue&type=script&lang=js"

import "./BsTemplateOwnerView.vue?vue&type=style&index=0&id=0304c5c7&scoped=true&lang=css"
import "./BsTemplateOwnerView.vue?vue&type=style&index=1&id=0304c5c7&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0304c5c7"]])

export default __exports__